import { module } from 'angular';

import { default as epticaDeprecatedServiceName, EpticaDeprecatedService } from './eptica-deprecated.service';

export default module('contact.agent.core.channel-digit.mail.eptica', []).service(epticaDeprecatedServiceName, EpticaDeprecatedService)
  .name;
